module.exports = __webpack_public_path__ + "img/abkhazia.028f0e72.svg";